import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkCreatePolygonActions from "../../store/actions/BulkCreatePolygon";
import BulkUploadFile from "../BulkUploadFile";

//change
const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
  "Order of columns of CSV file should be: 'polygon_name,polygon_type,city_id,zone_id,ref_id,is_active,boundary'",
  "Provide ref_id as reference id of polygon.",
  "Provide boundary in following format: '[[lat1,lng1],[lat2,lng2],[lat3,lng3],[lat4,lng4]]'",
];

const FileUploadModal = ({ getUploadUrl }) => {

  return (
    <BulkCreatePolygonModal>
       <BulkUploadFile
        instructions={instructions}
        btnDataTestID="BulkCreatePolygon"
        uploadUrl="/polygon/bulk-create/ack"
        sampleURL="/sample/bulk_create_polygon.csv"
        id="BulkCreatePolygonModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Create Polygon"
        useUserUploadedFilename={true}
        getUploadUrl={getUploadUrl}
        validationType="BulkCreatePolygon"
        maxSize={0.5} // in mb
      />
    </BulkCreatePolygonModal>
  );
};

const BulkCreatePolygonModal = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      BulkCreatePolygonActions.BulkCreatePolygon,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);